import {
  afterNextRender,
  ChangeDetectionStrategy,
  Component,
  computed,
  DestroyRef,
  ElementRef,
  inject,
  input,
  NgZone,
  output,
  signal,
} from '@angular/core';
import { Button2Component } from '@frontendlib/components/components/button/button2.component';
import { hubClearLabel, hubResultsLabel, observeHubWidth } from '../hub-search';
import { isCompactHubWidth } from '../hub-tabs';

/**
 * The row above the hub's list: with a search or a filter applied it reports the active tab's results and offers
 * the one clear action; either way it carries the sort button, projected on the right.
 */
@Component({
  selector: 'app-entity-hub-results-header',
  standalone: true,
  templateUrl: './entity-hub-results-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Button2Component],
  host: {
    class: 'block',
  },
})
export class EntityHubResultsHeaderComponent {
  public readonly count = input(0);
  /** False while the count is still loading or failed to load: the row then names no number at all. */
  public readonly countKnown = input(true);
  public readonly searchApplied = input(false);
  public readonly filtersApplied = input(false);

  public readonly clear = output<void>();

  protected readonly width = signal(0);

  protected readonly visible = computed(() => this.searchApplied() || this.filtersApplied());
  protected readonly resultsLabel = computed(() => hubResultsLabel(this.count()));
  protected readonly clearLabel = computed(() =>
    hubClearLabel({
      searchApplied: this.searchApplied(),
      filtersApplied: this.filtersApplied(),
      compact: isCompactHubWidth(this.width()),
    }),
  );

  private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly ngZone = inject(NgZone);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    afterNextRender(() =>
      observeHubWidth(this.host.nativeElement, this.ngZone, this.destroyRef, (width) => this.width.set(width)),
    );
  }
}
